import { __extends } from "tslib";
import { getShadowElement } from '@tyler-components-web/core';
import { BaseAdapter } from '../core/adapters/base-adapter';
import { BACKDROP_CONSTANTS } from './backdrop-constants';
/**
 * Provides facilities for interacting with the internal DOM of `BackdropComponent`.
 */
var BackdropAdapter = /** @class */ (function (_super) {
    __extends(BackdropAdapter, _super);
    function BackdropAdapter(component) {
        var _this = _super.call(this, component) || this;
        _this._backdropElement = getShadowElement(component, BACKDROP_CONSTANTS.selectors.CONTAINER);
        return _this;
    }
    /**
     * Sets the backdrop element opacity.
     * @param opacity The opacity amount.
     */
    BackdropAdapter.prototype.setBackdropOpacity = function (opacity) {
        this._backdropElement.style.opacity = opacity.toString();
    };
    /**
     * Adds a click event to the backdrop container element.
     * @param type The event type.
     * @param listener The event listener.
     */
    BackdropAdapter.prototype.addBackdropEventListener = function (type, listener) {
        this._backdropElement.addEventListener('click', listener);
    };
    /**
     * Removes a click event from the backdrop container element.
     * @param type The event type.
     * @param listener The event listener.
     */
    BackdropAdapter.prototype.removeBackdropEventListener = function (type, listener) {
        this._backdropElement.removeEventListener('click', listener);
    };
    return BackdropAdapter;
}(BaseAdapter));
export { BackdropAdapter };
